"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callbackStepsViaDefinitionRecursionDFS = exports.getNextSteps = exports.hasNextStep = exports.isCondition = exports.isTask = exports.findStep = exports.getVariables = exports.generateVariable = exports.getRootStep = exports.parse = void 0;
const assert_1 = require("assert");
const expression_helper_1 = require("@whispir/expression-helper");
const { STRING, NUMBER, DATE, ARRAY_OF_STRING } = expression_helper_1.variableIds;
exports.parse = (definition) => {
    try {
        const jsonItem = typeof definition === 'string' ? JSON.parse(definition) : definition;
        return jsonItem;
    }
    catch (error) {
        throw new Error('Workflow definition could not be parsed');
    }
};
exports.getRootStep = (wf) => {
    if (typeof wf === 'string') {
        throw new Error('Workflow definition is not valid JSON');
    }
    const [rootStep] = wf;
    return rootStep;
};
/**
 * @deprecated this function should reside in `@whispir/workflow-factory`
 */
exports.generateVariable = ({ variableId, value, valueType, }) => ({
    variableId,
    value,
    valueType,
});
exports.getVariables = (outputVariables, formVariables) => {
    const variablesWithTypes = [];
    if (!outputVariables) {
        return [];
    }
    outputVariables.forEach(({ variableId, variableType }) => {
        const foundVariable = formVariables.find(({ name }) => name === variableId);
        if (!foundVariable) {
            let defaultVariable;
            switch (variableType) {
                case STRING: {
                    defaultVariable = exports.generateVariable({
                        variableId,
                        value: '',
                        valueType: STRING,
                    });
                    break;
                }
                case NUMBER: {
                    defaultVariable = exports.generateVariable({
                        variableId,
                        value: 'NaN',
                        valueType: NUMBER,
                    });
                    break;
                }
                case DATE: {
                    defaultVariable = exports.generateVariable({
                        variableId,
                        value: 'NaN',
                        valueType: DATE,
                    });
                    break;
                }
                case ARRAY_OF_STRING: {
                    defaultVariable = exports.generateVariable({
                        variableId,
                        value: '[]',
                        valueType: ARRAY_OF_STRING,
                    });
                    break;
                }
                default:
                    // eslint-disable-next-line max-len
                    throw new Error(`Variable with id ${variableId} has invalid variableType: ${variableType}`);
            }
            return variablesWithTypes.push(defaultVariable);
        }
        const { value } = foundVariable;
        const variableWithType = exports.generateVariable({
            variableId,
            value,
            valueType: variableType,
        });
        return variablesWithTypes.push(variableWithType);
    });
    console.log('variable list to be persisted in db :', variablesWithTypes);
    return variablesWithTypes;
};
exports.findStep = ({ definition, stepId, }) => {
    assert_1.strict(definition, 'Please specify workflow to search');
    assert_1.strict(typeof stepId !== 'undefined' && stepId !== null, 'Please specify stepId to search for');
    let step = definition.find((el) => el.id === stepId);
    if (step) {
        return step;
    }
    for (let i = 0, len = definition.length; i < len; i += 1) {
        if (definition[i].next) {
            step = exports.findStep({ definition: definition[i].next, stepId });
            if (step) {
                return step;
            }
        }
    }
    return undefined;
};
exports.isTask = (step) => step.type === 'task';
exports.isCondition = (step) => step.type === 'condition';
exports.hasNextStep = (step) => step.next && step.next.length > 0;
exports.getNextSteps = ({ wf, stepId, }) => {
    assert_1.strict(wf, 'Provide "wf"');
    assert_1.strict(stepId !== undefined, 'Provide "stepId"');
    const found = exports.findStep({ definition: wf, stepId });
    if (!found) {
        return undefined;
    }
    return found.next;
};
// Recurse through the workflow definition, calling the stepCallback Depth-First
exports.callbackStepsViaDefinitionRecursionDFS = ({ step, definition, stepCallback, }) => {
    stepCallback(step);
    const nextSteps = exports.getNextSteps({ wf: definition, stepId: step.id });
    if (!nextSteps) {
        return;
    }
    // Perform migrations on the next steps
    nextSteps.forEach((nextStep) => exports.callbackStepsViaDefinitionRecursionDFS({
        step: nextStep,
        definition,
        stepCallback,
    }));
};
//# sourceMappingURL=workflowDefinition.js.map